import { v4 as uuidv4 } from "uuid"

import { ItemPreviewDto } from "./Item"
import { RetroStackItemsList } from "./RetroStackItemsList"

export interface ActionItemsDTO {
  retrospectiveNoteId?: string
  itemId?: string
  improvementPlan: string
  priority?: number
  itemPreviewDto?: ItemPreviewDto
  selectedNote?: RetroStackItemsList[]
}

export interface ActionItemsProps {
  retrospectiveNoteId?: string
  itemId?: string
  itemPreviewDto?: ItemPreviewDto
  improvementPlan: string
  priority?: number
  selectedNote?: RetroStackItemsList[]
}

export class ActionItems {
  localId: string
  retrospectiveNoteId?: string
  itemId?: string
  itemPreviewDto?: ItemPreviewDto
  improvementPlan: string
  priority: number
  selectedNote: RetroStackItemsList[]

  constructor(props?: ActionItemsProps) {
    this.setDefaultData()
    if (!props) return

    const { retrospectiveNoteId, improvementPlan, priority, selectedNote, itemId, itemPreviewDto } =
      props

    this.retrospectiveNoteId = retrospectiveNoteId
    this.improvementPlan = improvementPlan
    this.selectedNote = selectedNote ?? []
    this.priority = priority ?? 0
    this.itemId = itemId ?? ""
    this.itemPreviewDto = itemPreviewDto
  }

  static create(retroNoteDTO?: ActionItemsDTO): ActionItems {
    if (retroNoteDTO) {
      const {
        retrospectiveNoteId,
        itemId,
        improvementPlan,
        priority,
        selectedNote,
        itemPreviewDto
      } = retroNoteDTO

      const retroNote = new ActionItems({
        retrospectiveNoteId: retrospectiveNoteId,
        improvementPlan: improvementPlan,
        priority: priority,
        selectedNote: selectedNote,
        itemId: itemId,
        itemPreviewDto: itemPreviewDto
      })
      return retroNote
    }
    return new ActionItems()
  }

  setDefaultData() {
    this.localId = uuidv4()
    this.retrospectiveNoteId = ""
    this.improvementPlan = ""
    this.selectedNote = []
    this.priority = 0
    this.itemId = ""
    this.itemPreviewDto = undefined
  }

  getJsonObj() {
    return {
      retrospectiveNoteId: this.selectedNote?.[0].id ?? "",
      improvementPlan: this.improvementPlan,
      priority: this.priority,
      itemId: this.itemId
    }
  }
}
